import { render, staticRenderFns } from "./BotoesItens.vue?vue&type=template&id=1e33d7df"
import script from "./BotoesItens.vue?vue&type=script&lang=js"
export * from "./BotoesItens.vue?vue&type=script&lang=js"
import style0 from "./BotoesItens.vue?vue&type=style&index=0&id=1e33d7df&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports